import PropTypes from "prop-types"
import { Icon } from "@mui/material"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import CategoryArrowIcon from "components/icons/CategoryArrowIcon"
import {
  containerStyle,
  headerStyle,
  itemStyle,
  logoImageStyle,
  logoStyle,
  subTitleStyle,
  titleStyle,
} from "./style"
import { useLazyGetDashboardTeacherQuery } from "shared/redux/endpoints/sso"
import { useSelector } from "react-redux"
import { useGetHubMutation } from "shared/redux/endpoints/sso"
import InfoIcon, { TooltipIconColor, TooltipType } from "components/InfoIcon"
import { teacherInfoIconBlock } from "components/InfoIcon/teacherInfoIcon"
import makeStyles from "pages/style"
import React, { useEffect, useState } from "react"
import { Loading } from "shared/components/ui/Loading"
import axios from "axios"
import { globalConfigs } from "configs"
// import CategoryBoxIcon from "components/icons/CategoryBoxIcon";

const Category = ({ index, category }) => {
  const [trigger] = useLazyGetDashboardTeacherQuery()
  const [getHub] = useGetHubMutation()
  const user = useSelector((state) => state.auth.user)
  const { email, userId } = user
  const classes = makeStyles()
  const [dataCategory, setDataCategory] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    setDataCategory(category.items)
    setIsLoading(false)
  }, [category.header])

  const openLmsWithSSO = async () => {
    try {
      const res = await axios.post(
        globalConfigs.urlSSOLms + "/auth/redirect-my-apollo/generate",
        { hubUserId: userId, LXOId: userId, type: "TEACHER_SCHEDULE" },
        { headers: { "x-api-key": globalConfigs.apiKeySSO } }
      )
      const redirectLink = res?.data?.redirectLink
      if (redirectLink) {
        window.open(redirectLink, "_blank")
      } else {
        window.open("https://tailored.apollo.edu.vn/login", "_blank")
      }
    } catch {
      window.open("https://tailored.apollo.edu.vn/login", "_blank")
    }
  }

  const handleGetHub = async (e, item) => {
    switch (item.title) {
      case "LMS":
        await openLmsWithSSO()
        break
      case "WeLearn":
        const linkToWeLearn = `https://welearn.apollo.vn/s-s-o?magic=${encodeURIComponent(
          email
        )}&type=${1}`
        window.open(linkToWeLearn, "_blank")
        break
      case "HUB 24":
        const resHub24 = await getHub({
          redirectURL: "http://hub24.apollo.vn:10001/user/profile",
        })
        const dataHub24 = resHub24?.data?.data
        if (dataHub24) {
          window.open(dataHub24, "_blank")
        }
        break
      default:
        window.open(item.link, "_blank")
        break
    }
  }

  return (
    <MDBox
      key={index}
      width="100%"
      sx={(theme) => containerStyle(theme, { index })}
      className={`category-${index}`}
    >
      <MDBox className={classes.containerDisplayFlex}>
        {category.header === "WORK STATION" && (
          <InfoIcon
            type={TooltipType.TYPE_2}
            teacherInfoIconBlock={teacherInfoIconBlock.WORK_STATION}
            color={TooltipIconColor.BLUE}
            className={classes.containerInfoIconWith2}
          >
            <MDTypography
              variant="h5"
              sx={(theme) => headerStyle(theme, { index })}
            >
              {category.header}
            </MDTypography>
          </InfoIcon>
        )}

        {category.header === "LINKS" && (
          <InfoIcon
            type={TooltipType.TYPE_2}
            teacherInfoIconBlock={teacherInfoIconBlock.LINKS}
            color={TooltipIconColor.BLUE}
            className={classes.containerInfoIconWith2}
          >
            <MDTypography
              variant="h5"
              sx={(theme) => headerStyle(theme, { index })}
            >
              {category.header}
            </MDTypography>
          </InfoIcon>
        )}
      </MDBox>

      <MDBox>
        {isLoading ? (
          <MDBox
            width="100%"
            height={300}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Loading style={{ width: 150, height: 100 }} />
          </MDBox>
        ) : (
          dataCategory.map((item, _index) => {
            return (
              <MDBox
                key={`category-${_index}`}
                sx={(theme) => itemStyle(theme, { index })}
                onClick={(e) => handleGetHub(e, item)}
              >
                <MDBox sx={(theme) => logoStyle(theme, { index })}>
                  {typeof item.logo === "string" ? (
                    <MDBox
                      component="img"
                      src={item.logo}
                      sx={(theme) => logoImageStyle(theme)}
                    />
                  ) : (
                    item.logo
                  )}
                </MDBox>

                <MDBox sx={{ flexGrow: 1, flexBasis: 0 }}>
                  <MDTypography sx={(theme) => titleStyle(theme, { index })}>
                    {item.title}
                  </MDTypography>
                  <MDTypography
                    paragraph
                    sx={(theme) => subTitleStyle(theme, { index })}
                  >
                    {item.subtitle}
                  </MDTypography>
                </MDBox>

                <MDBox>
                  <Icon
                    component={() => <CategoryArrowIcon fill={"#172B4D"} />}
                  />
                </MDBox>
              </MDBox>
            )
          })
        )}
      </MDBox>
    </MDBox>
  )
}

Category.propTypes = {
  index: PropTypes.number.isRequired,
  category: PropTypes.shape({
    header: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.object),
  }),
}

export default Category
